  <div class="col-md-12 header-class">
    <h2>Rechercher un fournisseur</h2>
    <div>
      <a (click)="onModalCancel()" class="close-button">
        <mat-icon class="close-icon">close</mat-icon>
      </a>
    </div>
  </div>
 
  <div class="col-md-12">
    <div class="tabResponsives mat-elevation-z8">
      <mat-accordion>
        <mat-expansion-panel [(expanded)]="panelOpenState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Filtres
            </mat-panel-title>
            <mat-panel-description>
            {{ panelOpenState ? 'Réduire' : 'Ouvrir pour ajouter des filtres'}}
            </mat-panel-description>
            <div class="pull-right" >
              <div class="col-md-1">
                <mat-spinner *ngIf="loading" diameter="40"></mat-spinner>
              </div>
            </div>
            <div class="pull-right" >
              <div class="col-md-1">
                <button *ngIf="panelOpenState" matTooltip="Rechercher"  mat-raised-button color="primary"type="button" (click)="onChange($event)" mat-icon-button><mat-icon>search</mat-icon></button>
              </div>
            </div>
          </mat-expansion-panel-header>
 
          <div class="data-class row">
              <div class="col-md-4"> 
                <mat-form-field class="full-width">
                    <mat-label>Code fournisseur</mat-label>
                    <input [(ngModel)]="filtreData.code" matInput (keyup.enter)="onChange($event)" name="code"
                    style="font-size: small;" [ngModelOptions]="{standalone: true}">                </mat-form-field>
              </div>
              
              <div class="col-md-4">
                <mat-form-field class="full-width">
                    <mat-label>Libelle fournisseur</mat-label>
                    <input [(ngModel)]="filtreData.libelle" matInput (keyup.enter)="onChange($event)" name="libelle"
                          class="text-small" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="full-width">
                    <mat-label>N° de SIRET</mat-label>
                    <input [(ngModel)]="filtreData.siret" matInput (keyup.enter)="onChange($event)" name="siret"
                    class="text-small"  [ngModelOptions]="{standalone: true}">                
                </mat-form-field>
              </div>
    
              <div class="col-md-4">
                <mat-form-field class="full-width">
                    <mat-label>Ville</mat-label>
                    <input [(ngModel)]="filtreData.ville" matInput (keyup.enter)="onChange($event)" name="ville"
                    class="text-small"  [ngModelOptions]="{standalone: true}">                
                </mat-form-field>
              </div>  
         
              <div class="col-md-4">
                <mat-form-field class="full-width">
                    <mat-label>Code postal</mat-label>
                    <input [(ngModel)]="filtreData.cp" matInput (keyup.enter)="onChange($event)" name="cp"
                    class="text-small"  [ngModelOptions]="{standalone: true}">            
                </mat-form-field>
              </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <div style="margin-top: 30px;">
        <app-fournisseur-list [dataSource]="fournList"  [(filtreData)]="filtreData" (updateFournisseur)="setFournisseur($event)"
        [simpleQueryFournResponse]="simpleQueryFournResponse" ></app-fournisseur-list>
      </div>
    </div>
  </div>
  
  